module.exports = __webpack_public_path__ + "images/emoji/european_post_office.479fe98ff394bddfe5e8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/european_post_office.png
// module id = 7Is5
// module chunks = 14